import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Card, Input, Select, Tabs } from "antd";
import { AxiosGetSecretApi } from "../../../../utils/fetchApi";
import { changeMapLayer } from "../../../../redux/actions/map.action";

class SearchQHC extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listNamQH: [],
      listLoaiDat: [],
      listLoaiDatConst: [],
      selectedNamQH: undefined,
      selectedLoaiDat: undefined,
    };
  }


  async componentDidMount() {
    
    let res = await AxiosGetSecretApi("/api/qh-chung/cbNamQH");
    if (res && Array.isArray(res)) {
      this.setState({ listNamQH: res });
    }
    // if (this.props.isEnableLayer?.includes("QHC_Test")) {
    //   let url = "/api/qh-chung/cbLoaiDat"
    //   if('2020'){
    //     url = url + `?NamQH=${'2020'}`
    //   }
    //   let resLD = await AxiosGetSecretApi(url);
    //   if (resLD && Array.isArray(resLD)) {
    //     this.setState({ listLoaiDat: resLD});
    //   }
    //   this.setState({
    //   selectedNamQH: '2020'
    //   })
    // }else{
      this.getDataDuAn();
    // }
  }

  async getDataDuAn() {


    let resLD = await AxiosGetSecretApi("/api/qh-chung/cbLoaiDat");
    if (resLD && Array.isArray(resLD)) {
      this.setState({ listLoaiDat: resLD, listLoaiDatConst:  resLD});
    }
  }

  onResetButton() {
    this.setState({
      listLoaiDat: this.state.listLoaiDatConst,
      selectedNamQH: undefined,
      selectedLoaiDat: undefined,
    });
  }

  onSearch() {
    let data = {
      selectedNamQH: this.state.selectedNamQH,
    };
    if(this.state.selectedLoaiDat){
      this.props.onSearchLoaiDat(this.state.selectedLoaiDat);
      return
    }

    // console.log('this.state.selectedNamQH', typeof this.state.selectedNamQH);
    
    this.props.onSearchQHC(data);
  }
  onChangeNamQH =  async(value) => {
    // if(value === '2020'){
    //   this.props.changeMapLayer(["QHC_Test"]);
    // }else {
    //   this.props.changeMapLayer(["QHC_Polygon", "QHC_HienTrang"]);
    // }
    let url = "/api/qh-chung/cbLoaiDat"
    if(value){
      url = url + `?NamQH=${value}`
    }
    let resLD = await AxiosGetSecretApi(url);
    if (resLD && Array.isArray(resLD)) {
      this.setState({ listLoaiDat: resLD});
    }
    this.setState({
    selectedNamQH: value
  })
  }

  render() {
    return (
      <div className="popup-search" style={{zIndex: 13}}>
        <div className="title font-size-16">
          Tìm kiếm thông tin
          <i
            className="fas fa-times icon-close"
            onClick={() => {
              this.props.close();
            }}
          ></i>
        </div>

        <Card title="Quy hoạch chung 1/10000" size="small" >
          <div className="body">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <div>

                  <div className="group">
                    <div className="gr-title">
                      <div className="required">*</div>
                      <div className="text">Năm quy hoạch</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        value={this.state.selectedNamQH}
                        onChange={this.onChangeNamQH}
                      >
                        {this.state.listNamQH.map((e, i) => (
                          <Select.Option value={e.NamQH} key={i}>
                            {e.NamQH}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>

                  <div className="group">
                    <div className="gr-title">
                      <div className="text">Tên loại đất</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        value={this.state.selectedLoaiDat}
                        onChange={(value) => this.setState({
                          selectedLoaiDat: value,
                        })}
                      >
                        {this.state.listLoaiDat.map((e, i) => (
                          <Select.Option value={e.OBJECTID} key={i}>
                            {e.TenLoaiDat}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>

                </div>

                

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="primary"
                    className="button"
                    onClick={() => {
                      this.onResetButton();
                    }}
                  >
                    Tìm mới
                  </Button>
                  <Button
                    type="primary"
                    className="button"
                    onClick={() => {
                      this.onSearch();
                    }}
                    disabled={
                      this.state.selectedNamQH
                        ? false
                        : true
                    }
                  >
                    Tìm kiếm
                  </Button>
                </div>
              </div>
            </div>

            <div className="footer" style={{position: "unset"}}>
              <div style={{ display: "flex"}}>
                <div className="required">*</div>
                <div className="text">Thông tin bắt buộc</div>
              </div>
            </div>
          </Card>

        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // listQuan: state.search.listQuan,
    // listPhuong: state.search.listPhuong,
    // listDuong: state.search.listDuong,
    // listDuAn: state.search.listDuAn,
    // isEnableLayer: state.map.isEnableLayer,
  };
};

const mapDispatchToProps = {
  // getDataQuan: getDataQuan,
  // getDataPhuong: getDataPhuong,
  // getDataDuong: getDataDuong,
  changeMapLayer: changeMapLayer,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchQHC);
